import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, HStack, Modal, Text, Box, Pressable, Center } from "native-base";
import Trackable from "../../common/Trackable";
import i18next from "i18next";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import BrandIcon from "../../common/BrandIcon";

var DeliveryOrderFailedModal = function DeliveryOrderFailedModal(_ref) {
  var _store$delivery, _store$delivery$deliv;

  var isOpen = _ref.isOpen,
      _onClose = _ref.onClose,
      resetAndClose = _ref.resetAndClose;
  var store = useStore();
  var isMobile = store.isMobile;
  var restaurantNumber = (_store$delivery = store.delivery) === null || _store$delivery === void 0 ? void 0 : (_store$delivery$deliv = _store$delivery.deliveryModel) === null || _store$delivery$deliv === void 0 ? void 0 : _store$delivery$deliv.previousRestaurantNumber;
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    onClose: function onClose() {
      return _onClose();
    },
    bg: "rgba(0,0,0,0.4)",
    children: /*#__PURE__*/_jsxs(Modal.Content, {
      maxWidth: "420px",
      p: 0,
      bg: "modalLightBg",
      children: [/*#__PURE__*/_jsx(Modal.Header, {
        bg: "emptyCartHeaderBgColor",
        roundedTop: 7,
        p: 0,
        children: /*#__PURE__*/_jsxs(HStack, {
          py: 5,
          _web: {
            ml: isMobile ? [0, "27px", "27px"] : "0"
          },
          alignItems: "center",
          justifyContent: isMobile ? ["center", "flex-start", "flex-start"] : "center",
          position: "relative",
          children: [/*#__PURE__*/_jsx(Text, {
            textAlign: "center",
            fontSize: isMobile ? "md" : "lg",
            lineHeight: 4,
            color: "modalTextColor",
            fontWeight: 300,
            children: i18next.t("togo.deliveryOrderFailedModal.title", {
              defaultValue: "We're Sorry"
            })
          }), /*#__PURE__*/_jsx(Box, {
            position: "absolute",
            right: 6,
            children: /*#__PURE__*/_jsx(Trackable, {
              className: "trackContent",
              dataLinkInfo: "togo delivery time failed modal|close icon",
              children: /*#__PURE__*/_jsx(Pressable, {
                onPress: function onPress() {
                  return _onClose();
                },
                children: /*#__PURE__*/_jsx(BrandIcon, {
                  iconName: "close",
                  alt: "CloseIcon",
                  height: "20px",
                  width: "20px"
                })
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Modal.Body, {
        _web: {
          px: isMobile ? "20px" : "27px",
          py: isMobile ? "20px" : "22px"
        },
        children: /*#__PURE__*/_jsxs(Center, {
          children: [/*#__PURE__*/_jsx(BrandIcon, {
            iconName: "exception",
            alt: "time",
            _web: {
              height: "65px",
              width: "65px"
            },
            mr: 1.5,
            mt: 0.5,
            py: 2
          }), /*#__PURE__*/_jsx(Text, {
            pb: 2,
            pt: 4,
            color: "#4E311D",
            fontSize: 28,
            fontWeight: 500,
            textAlign: "center",
            children: i18next.t("togo.deliveryOrderFailedModal.text1", {
              defaultValue: "Your order cannot be placed at this time"
            })
          }), /*#__PURE__*/_jsx(Text, {
            fontSize: "md",
            fontWeight: 300,
            lineHeight: 5,
            textAlign: "center",
            color: "modalTextColor",
            py: 4,
            children: i18next.t("togo.deliveryOrderFailedModal.text2", {
              defaultValue: "Switch to Pickup to continue with your order and you can pick up from your nearest Olive Garden location"
            })
          }), /*#__PURE__*/_jsx(Box, {
            width: "100%",
            children: /*#__PURE__*/_jsx(Trackable, {
              className: "trackContent",
              dataLinkInfo: "togo delivery time failed modal|switch to pickup cta",
              children: /*#__PURE__*/_jsx(Button, {
                pb: 2,
                mt: 2,
                _text: {
                  textTransform: "uppercase",
                  color: "white",
                  lineHeight: 6,
                  fontSize: "md",
                  fontWeight: 300
                },
                onPress: function onPress() {
                  var _store$delivery2;

                  _onClose();

                  if (!store.delivery) {
                    var _store$menuList;

                    store === null || store === void 0 ? void 0 : (_store$menuList = store.menuList) === null || _store$menuList === void 0 ? void 0 : _store$menuList.deliveryToPickupSwitch(true, restaurantNumber);
                  } else store === null || store === void 0 ? void 0 : (_store$delivery2 = store.delivery) === null || _store$delivery2 === void 0 ? void 0 : _store$delivery2.deliveryToPickupSwitch(restaurantNumber);
                },
                children: i18next.t("togo.deliveryOrderFailedModal.pickupText", {
                  defaultValue: "Switch to pickup"
                })
              })
            })
          })]
        })
      })]
    })
  });
};

export default observer(DeliveryOrderFailedModal);